import React from "react";
import { Flame, HeartHandshake, Globe, Send } from "lucide-react";
import { useFetch } from "@/lib/api";
import { PageHero } from "@/components/blocks/PageHero";
import { Reveal } from "@/components/blocks/Reveal";
import { EmptyState } from "@/components/blocks/EmptyState";

const impacts = [
  { icon: Globe, title: "Reach the Nations", text: "Fund mega crusades and outreach into new territories." },
  { icon: Flame, title: "Fuel the Fire", text: "Support Jesus Caravan missions to remote villages and hinterlands." },
  { icon: HeartHandshake, title: "Bring the Harvest Home", text: "Enable follow-up, counselling and discipleship of new believers." },
];

const Giving = () => {
  const { data: g } = useFetch("/giving");

  return (
    <div>
      <PageHero
        overline="Support the Mission"
        title="Partner with the harvest"
        subtitle={g?.intro}
        image="https://images.unsplash.com/photo-1566996533071-2c578080c06e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <section className="bg-white py-24 md:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 md:grid-cols-3">
            {impacts.map((it, i) => (
              <Reveal key={it.title} delay={i * 0.06}>
                <div className="h-full border border-border bg-card p-8">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-sm bg-navy text-brand-orange">
                    <it.icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-semibold text-navy">{it.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{it.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-16">
            {g?.methods && g.methods.length > 0 ? (
              <div className="grid gap-6 md:grid-cols-2">
                {g.methods.map((mth, i) => (
                  <div key={i} className="border border-border bg-card p-8">
                    <h3 className="font-display text-lg font-semibold text-navy">{mth.name}</h3>
                    <p className="mt-2 text-sm text-muted-foreground">{mth.details}</p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-navy p-10 text-center md:p-16">
                <Send className="mx-auto h-12 w-12 text-brand-orange" />
                <h3 className="mt-6 font-display text-2xl font-bold text-white md:text-3xl">Giving options coming soon</h3>
                <p className="mx-auto mt-3 max-w-xl text-white/70">{g?.note}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Giving;
